import OwnableTheme from '@Theme';
import styled from 'styled-components/native';

export const StyledSmartHeaderContainer = styled.View`
  align-items: center;
  justify-content: center;
  flex-direction: row;
  align-self: center;
  margin-top: 40px;
`;

export const StyledButtonContainer = styled.View`
  width: 100%;
  margin-top: 10px;
  margin-bottom: 20px;
  align-items: center;
  padding: 15px 20px;
  border-radius: 12px;
  background-color: ${OwnableTheme.colors.black};
`;

export const StyledFormContainer = styled.View<{ marginTop?: number }>`
  padding: 20px;
  margin-top: ${({ marginTop }) => marginTop ?? 45}px;
`;
